export default async () => {
  try {
    const permission = await navigator.permissions.query({
      // @ts-ignore
      name: "periodic-background-sync",
    });
    if (permission.state !== "granted") {
      console.warn("Periodic sync permission not granted");
      return;
    }
    const registration = await navigator.serviceWorker.ready;
    // @ts-ignore
    await registration.periodicSync.register("periodic-cleanup", {
      minInterval: 24 * 60 * 60 * 1000, // 24 hours
    });
  } catch (error) {
    console.error("Error registering periodic sync:", error);
  }
};
